import { render } from "./ColorScale.vue?vue&type=template&id=4767e115&scoped=true"
import script from "./ColorScale.vue?vue&type=script&lang=js"
export * from "./ColorScale.vue?vue&type=script&lang=js"

import "./ColorScale.vue?vue&type=style&index=0&id=4767e115&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4767e115"]])

export default __exports__